import(/* webpackMode: "eager" */ "/app/src/app/(wca)/(with-background)/competitions/page.tsx");
